import React, { useEffect, useState } from "react";
import api, { API } from "@/lib/api";
import { ExternalLink } from "lucide-react";

export const BannerAd = () => {
  const [ad, setAd] = useState(null);

  useEffect(() => {
    let mounted = true;
    api.get("/ads/banner").then((r) => {
      if (mounted && r.data && r.data.id) {
        setAd(r.data);
        api.post(`/ads/${r.data.id}/impression`).catch(() => {});
      }
    }).catch(() => {});
    return () => { mounted = false; };
  }, []);

  if (!ad) return null;

  const onClick = () => {
    api.post(`/ads/${ad.id}/click`).catch(() => {});
    if (ad.link_url) window.open(ad.link_url, "_blank", "noopener");
  };

  return (
    <div className="px-6 md:px-12 relative z-10 my-2">
      <button onClick={onClick} data-testid="banner-ad"
        className="group relative block w-full overflow-hidden rounded-2xl border border-[#2a2a2a] hover:border-[#e2ff31]/50 transition-colors">
        <span className="absolute top-3 left-3 z-10 text-[10px] font-mono uppercase tracking-widest text-black bg-[#e2ff31] rounded-full px-2.5 py-1 font-bold">
          Ad
        </span>
        <img src={`${API}${ad.media_url}`} alt={ad.title || "Advertisement"}
          className="w-full max-h-48 object-cover group-hover:scale-[1.02] transition-transform duration-500" />
        {ad.title && (
          <span className="absolute bottom-3 right-3 z-10 flex items-center gap-1.5 text-sm font-medium bg-black/60 backdrop-blur rounded-full px-3 py-1.5">
            {ad.title} <ExternalLink className="w-3.5 h-3.5" />
          </span>
        )}
      </button>
    </div>
  );
};
